import RejectionApprovalNotice from "./RejectionApprovalNotice";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import StartStopJobCardModal from "./StartStopJobCardModal";
import Constants from "../../../../common/Constants";
import { Row, Col, Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import ItemService from "../../../../services/commonService";
import ListGroup from "react-bootstrap/ListGroup";
import Form from "react-bootstrap/Form";
import { toastFunc } from "../../../../components/common/util";
import { useNavigate } from "react-router-dom";
import { AlertModal } from "../../../common/AlertModal";
import OkQuantityModal from "./OkQuantityModal";
import ReworkQuantityModal from "./ReworkQuantityModal";
import ConfirmReworkJobCard from "./ConfirmReworkJobCard";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { fetchMasterListById } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import moment from "moment";
import ConsumptionQuantityModal from "./ConsumptionQuantityModal";

const OrderConfirmation = () => {
  const navigate = useNavigate();
  const [approval, setApproval] = useState(null);
  const [rejectionLimit, setRejectionLimit] = useState(null);
  const approvalPending = approval?.status === "Pending";
  const [open, setOpen] = useState(false);
  const [jobcardDetails, setJobcardDetails] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [okQtyModal, setOkQtyModal] = useState(false);
  const [consumptionQtyModal, setConsumptionQtyModal] = useState(false);
  const [consumptionModalType, setConsumptionModalType] = useState("");
  const [consumptionModalTitle, setConsumptionModalTitle] = useState("");
  const [reworkQtyModal, setReworkQtyModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [stopJobcardBtn, setStopJobcardButton] = useState(false);
  const [reworkItems, setReworkItems] = useState([]);
  const [closeJobcardBtn, setCloseJobcardBtn] = useState(false);
  const [reworkCompleteItems, setReworkCompleteItems] = useState([]);
  const [confirmDisable, setConfirmDisable] = useState(false);
  const [statusConfirmModel, setStatusConfirmModel] = useState(false);
  const [statusConfirmMessage, setStatusConfirmMessage] = useState("");
  const [statusStopModel, setStatusStopModel] = useState(false);
  const [statusCloseModel, setStatusCloseModel] = useState(false);
  const [okActualAmount, setOKActualAmount] = useState(0);
  const [rejectActualAmount, setRejectActualAmount] = useState(0);
  const [reworkActualAmount, setReworkActualAmount] = useState(0);
  const [reworkData, setReworkData] = useState([]);
  const [okModalType, setOkModalType] = useState("");
  const [okModalTitle, setOkModalTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [okData, setOkData] = useState([]);
  const [rejectData, setRejectData] = useState([]);
  const [sizeCode, setSizeCode] = useState("");
  const [targetDuration, setTargetDuration] = useState(0);
  const [toDeptCode, setToDeptCode] = useState("");
  // const [jobStatusValue, setJobStatus] = useState("");
  const [cummOkCount, setCummOkCount] = useState(0);
  const [cummRejectCount, setCummRejectCount] = useState(0);
  const [cummReworkCount, setCummReworkCount] = useState(0);
  const formRef = useRef(null);
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showChemicalBatch, setShowChemicalBatch] = useState("");
  const [editConsumptionData, setEditConsumptionData] = useState([]);
  const [savedConsumptionData, setSavedConsumptionData] = useState([]);
  const [consumptionReasonsList, setConsumptionReasonsList] = useState([]);

  const handleClose = () => {
    navigate("/home");
    setOpen(false);
  };
  const dispatch = useDispatch();

  const handleModalClose = () => {
    setOkQtyModal(false);
    setReworkQtyModal(false);
    setConsumptionQtyModal(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setOpen(true);
    }, 100);
  }, []);

  const getWeighingScaleData = async () => {
    try {
      let param = {
        url: "getWeightFromScale",
        page: Constants.TRANSACTION.ORDERCONFIRMATION.name,
      };
      await ItemService.getTransactionListDataById(param).then((item) => {
        if (item?.status === 200 && item?.data.length > 0) {
        } else {
          console.log(">> Error: Loading getWeighingScaleData");
        }
      });
    } catch (error) {
      console.error("Error in handleStartStopSuccess:", error);
      toastFunc(
        Constants.MASTER.TOAST.error,
        t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
        4000,
      );
    }
  };

  const OrderConfList = async (
    jobcard,
    toDeptCode,
    order,
    quantityPerJobCard,
  ) => {
    if (!toDeptCode) return;
    try {
      let param = {
        url: "getOrderConfListByJobCard",
        page: Constants.TRANSACTION.ORDERCONFIRMATION.name,
        jobcard: jobcard,
        deptCode: toDeptCode,
        order: order,
      };
      await ItemService.getTransactionListDataById(param).then((item) => {
        if (item?.status === 200 && Array.isArray(item.data)) {
          setApproval(item.approval || null);
          setRejectionLimit(item.rejectionLimit);
          const okfilteredData = item?.data?.filter(
            (item) => item.jobstatus === "OK",
          );
          const rejectfilteredData = item?.data?.filter(
            (item) => item.jobstatus === "REJECT",
          );
          const reworkfilteredData = item?.data?.filter(
            (item) => item.jobstatus === "REWORK",
          );
          const cumuOkCount = okfilteredData.reduce(
            (sum, item) => sum + Number(item.count),
            0,
          );
          const cumuRejecteCount = rejectfilteredData.reduce(
            (sum, item) => sum + Number(item.count),
            0,
          );
          const cummReworkCount = reworkfilteredData.reduce(
            (sum, item) => sum + Number(item.count),
            0,
          );
          let completeItems = [];
          let allItems = [];
          item?.data?.forEach((element) => {
            if (element.jobstatus === "REWORK-COMPLETE") {
              completeItems.push(element);
            }
            if (
              element.jobstatus === "REWORK-COMPLETE" ||
              element.jobstatus === "REWORK-CONFIRMED" ||
              element.jobstatus === "REWORK"
            ) {
              allItems.push(element);
            }
          });
          setReworkCompleteItems(completeItems);
          setReworkItems(allItems);
          setCummOkCount(cumuOkCount);
          setCummRejectCount(cumuRejecteCount);
          setCummReworkCount(cummReworkCount);

          const finalCount =
            parseInt(cumuOkCount) +
            parseInt(cumuRejecteCount) +
            parseInt(cummReworkCount);
          setConfirmDisable(Number(finalCount) >= Number(quantityPerJobCard));
          setCloseJobcardBtn(Number(finalCount) === Number(quantityPerJobCard));
        } else {
          console.log(">> Error: Loading OrderConfList");
        }
      });
    } catch (error) {
      console.error("Error in handleStartStopSuccess:", error);
      toastFunc(
        Constants.MASTER.TOAST.error,
        t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
        4000,
      );
    }
  };

  const handleOrderConfirmationSuccess = async (decodedText, pageVal) => {
    if (isProcessing) return; // Prevent multiple calls while processing
    setIsProcessing(true); // Set processing lock
    let param = {
      url: "getTransactionListDataById",
      page: Constants.TRANSACTION.GENERATEJOBCARD.name,
      jobcard: decodedText,
    };

    if (decodedText) {
      try {
        const item = await ItemService.getTransactionListDataById(param);
        if (item?.status === 200) {
          if (
            (item?.data.length > 0 &&
              item?.data[0]?.jobcardStatus ===
                Constants.TRANSACTION_STATUS.INPROGRESS) ||
            pageVal === "samepage"
          ) {
            setOpen(false);
            setJobcardDetails(item.data[0]);
            setToDeptCode(item?.data[0]?.toDeptCode);
            await getChemicalBatchByDept(item?.data[0]?.toDeptCode);
            await getConsumptionEnteredData(
              item.data[0].jobcard,
              item?.data[0]?.toDeptCode,
              item?.data[0]?.sizeCode,
            );
            await loadConsumptionReasons(
              item?.data[0]?.toDeptCode,
              item?.data[0]?.sizeCode,
            );
            await OrderConfList(
              item.data[0].jobcard,
              item?.data[0]?.toDeptCode,
              item.data[0]?.order,
              item.data[0]?.quantityPerJobCard,
            );
            setSizeCode(item?.data[0]?.sizeCode);
            if (
              item?.data[0]?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.STOPPED
            ) {
              setConfirmDisable(true);
            }
          } else {
            if (decodedText === "") {
              handleClose();
              toastFunc(
                Constants.MASTER.TOAST.error,
                t("msg_trasaction.msg_teamlead_acknowledge.jobcard_not_found"),
                4000,
              );
            } else {
              handleClose();
              toastFunc(
                Constants.MASTER.TOAST.error,
                "Jobcard Not started. Please Start JobCard first",
                4000,
              );
            }
          }
        } else {
          console.log(">> Error: Loading handleOrderConfirmationSuccess");
        }
      } catch (error) {
        console.error("Error in handleOrderConfirmationSuccess:", error);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
          4000,
        );
      } finally {
        setIsProcessing(false); // Reset lock after completion
      }
    } else {
      setIsProcessing(false); // Reset lock if no decodedText is provided
    }
  };

  const getActualAmount = (actAmt, statusCode, addedRowsData) => {
    if (statusCode === "OK") {
      setOKActualAmount(actAmt);
      setOkData(addedRowsData);
    } else if (statusCode === "REJECT") {
      setRejectActualAmount(actAmt);
      setRejectData(addedRowsData);
    } else if (statusCode === "REWORK") {
      setReworkActualAmount(reworkActualAmount + Number(actAmt));
      setReworkData([...reworkData, addedRowsData]);
    }
  };

  const handleOrderConfError = (errorMessage) => {
    console.error(" handleOrderConfError:", errorMessage);
  };

  const handleInputValue = (value) => {
    handleOrderConfirmationSuccess(value, "");
  };
  const resetAlert = () => {
    setIsAlert(false);
  };
  const handleOkQty = (type, title) => {
    setOkModalType(type);
    setOkModalTitle(title);
    setOkQtyModal(true);
  };

  const handleConsumptionQty = (type, title) => {
    setConsumptionModalType(type);
    setConsumptionModalTitle(title);
    setConsumptionQtyModal(true);
  };
  // eslint-disable-next-line no-unused-vars
  const handleReworkClick = () => {
    setReworkQtyModal(true);
  };
  // eslint-disable-next-line no-unused-vars
  // const handleStopJobcard = async () => {
  //   setStopJobcardBtn(true);
  // };

  useEffect(() => {
    let param = {};
    param.url = "getProcessMasterListDataById";
    param.page = Constants.MASTER.PROCESS.name;
    param.id = sizeCode;

    if (sizeCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        if (result?.payload?.data[0]) {
          let processFilter = result?.payload?.data[0]?.process.filter(
            (process) => process.deptCode === toDeptCode,
          );
          setTargetDuration(processFilter[0].cycleTime * 60);
        } else {
          setIsAlert(true);
          setAlertMessage(
            "Process Not set for Jobcard. Please set the process to proceed.",
          );
          navigate("/home");
          setOpen(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizeCode]);

  useEffect(() => {
    if (!jobcardDetails?.jobcard || !approvalPending) return undefined;
    const refresh = () => OrderConfList(jobcardDetails.jobcard, jobcardDetails.toDeptCode, jobcardDetails.order, jobcardDetails.quantityPerJobCard);
    const timer = setInterval(refresh, 15000);
    window.addEventListener("focus", refresh);
    return () => { clearInterval(timer); window.removeEventListener("focus", refresh); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobcardDetails.jobcard, jobcardDetails.toDeptCode, jobcardDetails.order, approvalPending]);

  const handleCloseJobcard = async () => {
    if (approvalPending) { setIsAlert(true); setAlertMessage("Rejection approval is pending. A different user must approve it before closing."); return; }
    if (isSubmitting) return;

    if (parseInt(cummReworkCount || 0) > 0 || reworkCompleteItems?.length > 0) {
      setIsAlert(true);
      setAlertMessage(
        t("msg_trasaction.order_confirmation.rework_quantity_error"),
      );
      return false;
    }

    const finalCount =
      Number(cummOkCount || 0) +
      Number(cummRejectCount || 0) +
      Number(cummReworkCount || 0);

    if (finalCount !== Number(jobcardDetails.quantityPerJobCard || 0)) {
      setIsAlert(true);
      setAlertMessage(t("msg_trasaction.startstop_jobcard.on_confirm_error"));
      return false;
    }

    try {
      setIsSubmitting(true);

      let currentStatus = jobcardDetails.jobcardStatus;

      if (currentStatus === Constants.TRANSACTION_STATUS.INPROGRESS) {
        const stopped = await handleStartStop("closejobcard");

        if (!stopped) {
          setIsAlert(true);
          setAlertMessage("Unable to stop jobcard before closing");
          return false;
        }

        currentStatus = Constants.TRANSACTION_STATUS.STOPPED;
      }

      if (currentStatus !== Constants.TRANSACTION_STATUS.STOPPED) {
        setIsAlert(true);
        setAlertMessage("Please Stop Jobcard Before Closing");
        return false;
      }

      const now = moment();

      const closeJobCardForm = {
        ...jobcardDetails,

        jobcard: jobcardDetails.jobcard,

        // IMPORTANT: backend uses this in jobcardFilter
        jobcardStatus: Constants.TRANSACTION_STATUS.OPEN,

        to: now.format("DD-MM-YYYY HH:mm:ss"),
        toDB: now.toDate(),

        toDeptCode: jobcardDetails.toDeptCode,
        toDeptName: jobcardDetails.toDeptName,
        toMachineCode: jobcardDetails.toMachineCode,
        toMachineName: jobcardDetails.toMachineName,

        sizeCode: jobcardDetails.sizeCode,
        sizeName: jobcardDetails.sizeName,

        order: jobcardDetails?.order,
        quantityPerJobCard: Number(cummOkCount || 0),

        timeZone:
          Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata",
      };

      const param = {
        timeZone:
          Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata",
        closeJobCardForm,
      };

      const item = await ItemService.completeJobcard(param);

      if (item?.status === 200) {
        toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
        handleClose();
      } else {
        toastFunc(
          Constants.MASTER.TOAST.error,
          item?.message || "Failed to complete jobcard",
          3000,
        );
      }
    } catch (error) {
      console.error("Error while closing jobcard:", error);
      toastFunc(
        Constants.MASTER.TOAST.error,
        "Failed to complete jobcard",
        3000,
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleStartStop = async (type) => {
    if (!jobcardDetails?.toMachineCode) {
      setIsAlert(true);
      setAlertMessage(t("msg_trasaction.startstop_jobcard.select_machine"));
      return false;
    }

    const now = moment();

    const startStopForm = {
      fromDeptCode: jobcardDetails.fromDeptCode,
      fromDeptName: jobcardDetails.fromDeptName,
      fromMachineCode: jobcardDetails.fromMachineCode,
      fromMachineName: jobcardDetails.fromMachineName,

      toDeptCode: jobcardDetails.toDeptCode,
      toDeptName: jobcardDetails.toDeptName,
      toMachineCode: jobcardDetails.toMachineCode,
      toMachineName: jobcardDetails.toMachineName,

      jobcard: jobcardDetails.jobcard,
      batchTotalQuantity: jobcardDetails.batchTotalQuantity,
      sizeCode: jobcardDetails.sizeCode,
      sizeName: jobcardDetails.sizeName,

      jobcardStatus: Constants.TRANSACTION_STATUS.STOPPED,

      toDB: now.toDate(),
      to: now.format("DD-MM-YYYY HH:mm:ss"),

      actualDuration: "",
      targetDuration: targetDuration,
      order: jobcardDetails?.order,
      timeZone:
        Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata",
    };

    const param = {
      url: "stopJobcard",
      startStopForm,
    };

    try {
      const item = await ItemService.startStopJobcard(param);

      if (item?.status === 200) {
        toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);

        setJobcardDetails((prev) => ({
          ...prev,
          jobcardStatus: Constants.TRANSACTION_STATUS.STOPPED,
        }));

        setStopJobcardButton(true);

        if (type === "stopjobcard") {
          await handleOrderConfirmationSuccess(
            jobcardDetails.jobcard,
            "samepage",
          );
        }

        return true;
      }

      toastFunc(Constants.MASTER.TOAST.error, "Failed to stop jobcard", 3000);
      return false;
    } catch (error) {
      console.error("Error while stopping jobcard:", error);
      toastFunc(Constants.MASTER.TOAST.error, "Failed to stop jobcard", 3000);
      return false;
    }
  };

  const handleConfirmRework = async (row) => {
    let param = {
      url: "confirmCompletedReworkItem",
      method: "confirmCompletedReworkItem",
      confirmForm: row,
    };

    try {
      const item = await ItemService.updateTransactionData(param);
      if (item?.status === 200) {
        toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
        await OrderConfList(
          jobcardDetails.jobcard,
          jobcardDetails?.toDeptCode,
          jobcardDetails?.order,
          jobcardDetails?.quantityPerJobCard,
        );
      } else {
        console.log(">> Error: Loading getApplicationMaster");
      }
    } catch (error) {
      console.error("Error while Confirming Rework Items: ", error);
    }
  };

  const handleConfirmAlert = () => {
    setStatusConfirmModel(true);
    setStatusConfirmMessage(rejectionLimit && Number(rejectActualAmount) >= rejectionLimit
      ? `Rejection ACTUAL quantity ${rejectActualAmount} meets the approval limit (${rejectionLimit}). Confirming will require a Supervisor to approve it before Close Jobcard.`
      : "Do you want to Confirm the Order");
  };

  const handleStopAlert = () => {
    setStatusStopModel(true);
  };

  const handleCloseAlert = () => {
    setStatusCloseModel(true);
  };

  const handleConfirm = async () => {
    if (approvalPending) return;
    if (isSubmitting) return; // Prevent multiple psubmissions

    const finalCount =
      parseInt(okActualAmount) +
      parseInt(rejectActualAmount) +
      parseInt(cummOkCount) +
      parseInt(cummRejectCount) +
      parseInt(cummReworkCount) +
      parseInt(reworkActualAmount);

    if (
      okActualAmount === 0 &&
      rejectActualAmount === 0 &&
      reworkActualAmount === 0
    ) {
      setIsAlert(true);
      setAlertMessage("Please Enter OK or REJECT quantity ");
      return false;
    }

    if (consumptionReasonsList.length !== 0) {
      if (
        okActualAmount >= 200 &&
        (!editConsumptionData || editConsumptionData.length === 0)
      ) {
        setIsAlert(true);
        setAlertMessage("Please enter consumption quantity.");
        return false;
      }
    }

    if (jobcardDetails.jobcardStatus === Constants.TRANSACTION_STATUS.STOPPED) {
      setIsAlert(true);
      setAlertMessage("Please Start Jobcard To Proceed");
      return false;
    }

    if (finalCount > jobcardDetails.quantityPerJobCard) {
      setIsAlert(true);
      setAlertMessage(
        "OK and REJECT quantity is exceeding Total Batch Quantity",
      );
      return false;
    }

    try {
      setIsSubmitting(true); // Lock further submissions

      const startStopForm = {
        deptCode: jobcardDetails.toDeptCode,
        deptName: jobcardDetails.toDeptName,
        machineCode: jobcardDetails.toMachineCode,
        machineName: jobcardDetails.toMachineName,
        jobcard: jobcardDetails.jobcard,
        batchTotalQuantity: jobcardDetails.batchTotalQuantity,
        quantityPerJobCard: Number(jobcardDetails.quantityPerJobCard),
        sizeCode: jobcardDetails.sizeCode,
        sizeName: jobcardDetails.sizeName,
        // "jobstatus":okModalType,
        //"count":finalCount,
        siliconize: jobcardDetails.siliconize,
        originalQuantityPerJobCard: Number(
          jobcardDetails.originalQuantityPerJobCard,
        ),
        priority: jobcardDetails.priority,
        orderConfirmStatus: "Confirmed",
        batch: jobcardDetails.batch,
        customerCode: jobcardDetails.customerCode,
        customerName: jobcardDetails.customerName,
        requiredDate: jobcardDetails.requiredDate,
        batchTotalQtyDozen: jobcardDetails.batchTotalQtyDozen,
        plan: jobcardDetails.plan,
        planType: jobcardDetails.planType,
        createdDate: "",
        createdUserId: "",
        createdUserName: "",
        timeZone: "",
        order: jobcardDetails?.order || 1,
        chemicalBatchNo: showChemicalBatch?.chemicalBatchNo,
        // chemicalName: showChemicalBatch?.chemicalName,
      };

      // Merge startStopForm into each object in okData and rejectData
      const updatedOkData = okData?.map((item) => ({
        ...item,
        ...startStopForm,
      }));

      const updatedRejectData = rejectData?.map((item) => ({
        ...item,
        ...startStopForm,
      }));

      const updateReworkData = reworkData?.map((item) => ({
        ...item,
        ...startStopForm,
      }));

      const ConsumptionData = editConsumptionData?.map((item) => ({
        ...item,
        ...startStopForm,
      }));

      let mergedObject = updatedOkData.concat(updatedRejectData);
      mergedObject = mergedObject.concat(updateReworkData);
      mergedObject = mergedObject.concat(ConsumptionData);

      const param = {
        method: "confirmOrderConfirmation",
        confirmationRequestId:
          typeof crypto !== "undefined" && crypto.randomUUID
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        confirmData: Object.values(mergedObject),
      };
      const item = await ItemService.addTransactionData(param);
      if (item?.status === 200) {
        toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
        if (item.approvals?.length) setApproval(item.approvals[0]);
        await OrderConfList(
          jobcardDetails.jobcard,
          jobcardDetails.toDeptCode,
          jobcardDetails.order,
          jobcardDetails.quantityPerJobCard,
        );
        setOKActualAmount(0);
        setRejectActualAmount(0);
        setReworkActualAmount(0);
        setOkData([]);
        setRejectData([]);
        setReworkData([]);
        if (finalCount === jobcardDetails.quantityPerJobCard) {
          setCloseJobcardBtn(true);
          setConfirmDisable(true);
        }
        setEditConsumptionData([]);
        await getConsumptionEnteredData(
          jobcardDetails.jobcard,
          jobcardDetails.toDeptCode,
          jobcardDetails.sizeCode,
        );
      } else {
        setIsAlert(true);
        setAlertMessage(item?.message || "Unable to confirm the quantity.");
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setIsSubmitting(false); // Unlock for future calls
    }
  };

  const getChemicalBatchByDept = async (deptCode) => {
    let param = {
      deptCode,
    };
    await ItemService.getChemicalBatchByDept(param).then((item) => {
      // console.log(">>setShowChemicalBatch Details res!", item);
      if (item?.status === 200) {
        setShowChemicalBatch(item.data[0]);
      }
    });
  };

  const getConsumptionEnteredData = async (jobcard, deptCode, sizeCode) => {
    let param = {
      jobcard,
      deptCode,
      sizeCode,
    };
    await ItemService.getConsumptionEnteredData(param).then((item) => {
      // console.log(">>setShowChemicalBatch Details res!", item);
      if (item?.status === 200) {
        setSavedConsumptionData(item.data);
      }
    });
  };

  const loadConsumptionReasons = async (deptCode, sizeCode) => {
    if (!deptCode || !sizeCode) return;

    try {
      const param = {
        deptCode,
        sizeCode,
      };

      const item = await ItemService.getConsumptionReasons(param);
      if (item?.status === 200) {
        setConsumptionReasonsList(item?.data || []);
      }
    } catch (error) {
      console.error("Error while loading consumption reasons", error);
    }
  };

  const handleSaveSuccess = (data) => {
    const normalizedData = data.map((item) => ({
      ...item,
      reasonCode: "CONSUMPTION",
      jobstatus: "CONSUMPTION",
      reasonName: "CONSUMPTION",
      count: Number(item.quantity || 0),
    }));

    setEditConsumptionData(normalizedData);
  };

  return (
    <main className="OrderConfirmation main" id="main">
      <Form noValidate ref={formRef}>
        <Card className="">
          <Card.Header>
            <Button
              type="button"
              variant="primary"
              className="btn btn-primary btn-xs navigateBackButton"
              onClick={() => navigate("/home")}
            >
              <i class="bi bi-arrow-left back"> </i>
              <span className="back"> {t("msg_common.Back")}</span>
            </Button>

            <h5 className="machineStatusTitle">
              {" "}
              {`Order Confirmation - ${jobcardDetails?.jobcard}`}
            </h5>

            {jobcardDetails?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
              <p className="bg-table-status bg-table-warning-status acknowledmentStatus">
                {jobcardDetails.jobcardStatus}
              </p>
            )}

            {jobcardDetails?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.INPROGRESS && (
              <p className="bg-table-status bg-table-success-status acknowledmentStatus">
                {jobcardDetails.jobcardStatus}
              </p>
            )}

            {jobcardDetails?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.STOPPED && (
              <p className="bg-table-status bg-table-danger-status acknowledmentStatus">
                {jobcardDetails.jobcardStatus}
              </p>
            )}
          </Card.Header>
          <Card.Body className="ps-3">
            <RejectionApprovalNotice approval={approval} onRefresh={() => OrderConfList(jobcardDetails.jobcard, jobcardDetails.toDeptCode, jobcardDetails.order, jobcardDetails.quantityPerJobCard)} />
            <Card>
              <Row>
                <Col lg={6} md={6} sm={12}>
                  <ListGroup variant="flush" className="jobcard-detail-list">
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.customer")}{" "}
                        :{" "}
                      </span>{" "}
                      {jobcardDetails.customerCode}{" "}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.requiredDate")}{" "}
                        :{" "}
                      </span>{" "}
                      {jobcardDetails.requiredDate}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.plan")} :{" "}
                      </span>{" "}
                      {jobcardDetails.planType}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>{"Machine"} : </span> {jobcardDetails.toMachineCode}
                      {/* {" "}- {jobcardDetails.toMachineName} */}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.batchQuantity")}{" "}
                        :{" "}
                      </span>{" "}
                      <p
                        className="bg-table-status bg-table-new-status"
                        style={{ display: "inline" }}
                      >
                        <b>{jobcardDetails.quantityPerJobCard}</b> -{" "}
                        {parseInt(cummOkCount) +
                          parseInt(cummRejectCount) +
                          parseInt(cummReworkCount)}{" "}
                        ={" "}
                        {parseInt(jobcardDetails.quantityPerJobCard) -
                          (parseInt(cummOkCount) +
                            parseInt(cummRejectCount) +
                            parseInt(cummReworkCount))}
                      </p>
                    </ListGroup.Item>
                    {jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                      <ListGroup.Item className="m-2"></ListGroup.Item>
                    )}
                  </ListGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <ListGroup variant="flush" className="jobcard-detail-list">
                    <ListGroup.Item>
                      <span>{"Jobcard Number"} : </span>{" "}
                      {jobcardDetails.jobcard}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.size")} :{" "}
                      </span>{" "}
                      {jobcardDetails.sizeCode} ({jobcardDetails.sizeName})
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>{"Department"} : </span> {jobcardDetails.toDeptCode}{" "}
                      - {jobcardDetails.toDeptName}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>{"Chemical"} : </span>
                      {showChemicalBatch ? (
                        <>
                          <span className="bg-table-status bg-table-new-status py-0 mx-1">
                            Batch: {showChemicalBatch?.chemicalBatchNo}
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.startstop_jobcard.total_quantity")}{" "}
                        :{" "}
                      </span>{" "}
                      {jobcardDetails.batchTotalQuantity}
                    </ListGroup.Item>
                    {jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                      <ListGroup.Item></ListGroup.Item>
                    )}
                  </ListGroup>
                </Col>
              </Row>
            </Card>
            {
              reworkItems?.length > 0 && (
                <>
                  <ConfirmReworkJobCard
                    rowsData={reworkItems}
                    handleConfirm={handleConfirmRework}
                  />
                </>
              )

              // <Card>
              //   <CardHeader>
              //     <h5 className="machineStatusTitle">
              //       {t('msg_trasaction.rework_jobcard.rework_confirm_header')}
              //     </h5>
              //   </CardHeader>
              //   <CardBody>
              //     <ConfirmReworkJobCard
              //       rowsData={reworkCompleteItems}
              //       handleConfirm={handleConfirmRework}
              //     >
              //     </ConfirmReworkJobCard>
              //   </CardBody>
              // </Card>
            }
            <Row>
              <Col
                className="d-flex justify-content-center"
                lg={3}
                md={3}
                sm={12}
              >
                <Card
                  border="success"
                  key={""}
                  text={"success"}
                  className="mb-2"
                  style={{ width: "18rem" }}
                >
                  <Card.Body>
                    <div class="card-body-row row">
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-left">
                          <strong class="column-card-heading">CUMML</strong>
                          <div class="oc-header-value">{cummOkCount}</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-right">
                          <strong class="column-card-heading">ACTUAL</strong>
                          <div class="oc-header-value">{okActualAmount}</div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Footer className="order-conf-footer">
                    <Button
                      type="button"
                      variant="success"
                      className="btn btn-success"
                      size="lg"
                      onClick={() => handleOkQty("OK", "Enter OK Quantity")}
                    >
                      {"OK QTY"}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>

              <Col
                className="d-flex justify-content-center"
                lg={3}
                md={3}
                sm={12}
              >
                <Card
                  border="danger"
                  key={""}
                  text={"white"}
                  style={{ width: "18rem" }}
                  className="mb-2"
                >
                  <Card.Body>
                    <div class="card-body-row row">
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-left">
                          <strong class="column-card-heading">CUMML</strong>
                          <div class="oc-header-value">{cummRejectCount}</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-right">
                          <strong class="column-card-heading">ACTUAL</strong>
                          <div class="oc-header-value">
                            {rejectActualAmount}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Footer className="order-conf-footer">
                    <Button
                      type="button"
                      variant="danger"
                      className="btn btn-danger"
                      size="lg"
                      onClick={() =>
                        handleOkQty("REJECT", "Enter Reject Quantity")
                      }
                    >
                      {"REJECT QTY"}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>

              <Col
                className="d-flex justify-content-center"
                lg={3}
                md={3}
                sm={12}
              >
                <Card
                  border="warning"
                  key={""}
                  text={"white"}
                  className="mb-2"
                  style={{ width: "18rem" }}
                >
                  <Card.Body>
                    <div class="card-body-row row">
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-left">
                          <strong class="column-card-heading">CUMML</strong>
                          <div class="oc-header-value">{cummReworkCount}</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-right">
                          <strong class="column-card-heading">ACTUAL</strong>
                          <div class="oc-header-value">
                            {reworkActualAmount}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Footer className="order-conf-footer">
                    <Button
                      type="button"
                      variant="warning"
                      className="btn btn-warning"
                      size="lg"
                      onClick={() => handleReworkClick()}
                    >
                      {"REWORK QTY"}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
              <Col
                className="d-flex justify-content-center"
                lg={3}
                md={3}
                sm={12}
              >
                <Card
                  border="info"
                  key={""}
                  text={"white"}
                  style={{ width: "18rem" }}
                  className="mb-2"
                >
                  <Card.Body style={{ padding: "8px 10px 0px 12px" }}>
                    {editConsumptionData?.length > 0 ? (
                      <div className="consumption-scroll">
                        {editConsumptionData &&
                          editConsumptionData.map((item, index) => (
                            <div className="consumption-mini-card" key={index}>
                              <div className="consumption-left">
                                <div className="consumption-type">
                                  {item.consumptionType}
                                </div>

                                <div className="consumption-size">
                                  {item.consumableSize}
                                </div>
                              </div>

                              <div className="consumption-right">
                                <div className="qty-label">Qty</div>
                                <div className="qty-value">{item.quantity}</div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ) : (
                      <div className="no-consumption-data">
                        <i className="bi bi-info-circle me-2"></i>
                        No Consumption Data
                      </div>
                    )}
                  </Card.Body>
                  <Card.Footer className="order-conf-footer">
                    <Button
                      type="button"
                      variant="info"
                      className="btn btn-info"
                      size="lg"
                      onClick={() =>
                        handleConsumptionQty(
                          "CONSUMPTION",
                          "Enter Consumption Quantity",
                        )
                      }
                    >
                      {"CONSUMPTION QTY"}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          </Card.Body>
          <br />
          {
            <Card.Footer className="text-center machine-status-footer-button">
              <Button
                type="button"
                variant="success"
                size="lg"
                className="btn btn-success"
                data-dismiss="modal"
                disabled={confirmDisable || isSubmitting || approvalPending || jobcardDetails.jobcardStatus === Constants.TRANSACTION_STATUS.STOPPED}
                onClick={() => handleConfirmAlert()}
              >
                {"CONFIRM"}
              </Button>

              <Button
                type="button"
                variant="danger"
                size="lg"
                className="btn btn-danger"
                onClick={() => navigate("/home")}
                data-dismiss="modal"
              >
                {t("msg_common.set_cancel")}
              </Button>

              <Button
                type="button"
                variant="warning"
                size="lg"
                className="btn btn-warning"
                data-dismiss="modal"
                disabled={stopJobcardBtn}
                onClick={() => handleStopAlert()}
              >
                {"STOP JOBCARD"}
              </Button>
              <br />
              <br />
              <Row className="text-center machine-status-footer-button">
                <Col lg={12} md={12} sm={12}>
                  {closeJobcardBtn && (
                    <Button
                      type="button"
                      variant="success"
                      size="lg"
                      className="btn btn-success"
                      data-dismiss="modal"
                      disabled={approvalPending || isSubmitting}
                      onClick={() => handleCloseAlert()}
                    >
                      {"CLOSE JOBCARD"}
                    </Button>
                  )}
                </Col>
              </Row>
            </Card.Footer>
          }
        </Card>
        {open && (
          <StartStopJobCardModal
            show={open}
            onHide={handleClose}
            handleSuccess={handleOrderConfirmationSuccess}
            handleError={handleOrderConfError}
            onButtonClick={handleInputValue}
            title={"Scan the Jobcard to Confirm Order"}
            pageId={"orderConfirmation"}
            //onSave={handleSave}
          ></StartStopJobCardModal>
        )}
      </Form>
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={alertMessage}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
      {okQtyModal && (
        <OkQuantityModal
          show={setOkQtyModal}
          onHide={handleModalClose}
          title={okModalTitle}
          jobStatusCode={okModalType}
          deptCode={jobcardDetails.toDeptCode}
          accumulateActualValue={getActualAmount}
          getWeighingScaleData={getWeighingScaleData}
        ></OkQuantityModal>
      )}
      {reworkQtyModal && (
        <ReworkQuantityModal
          show={setOkQtyModal}
          onHide={handleModalClose}
          title={okModalTitle}
          jobStatusCode={"REWORK"}
          deptCode={jobcardDetails.toDeptCode}
          accumulateActualValue={getActualAmount}
          sizeCode={jobcardDetails.sizeCode}
        ></ReworkQuantityModal>
      )}

      {statusConfirmModel && (
        <ConfirmationModal
          show={statusConfirmModel}
          heading={t("msg_common.confirmation")}
          bodyMessage={statusConfirmMessage}
          onOk={() => {
            handleConfirm();
            setStatusConfirmModel(false);
          }}
          onHide={() => setStatusConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}

      {statusStopModel && (
        <ConfirmationModal
          show={statusStopModel}
          heading={t("msg_common.confirmation")}
          bodyMessage={"Do you want to Stop Jobcard ?"}
          onOk={() => {
            handleStartStop("stopjobcard");
            setStatusStopModel(false);
          }}
          onHide={() => setStatusStopModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}

      {statusCloseModel && (
        <ConfirmationModal
          show={statusCloseModel}
          heading={t("msg_common.confirmation")}
          bodyMessage={"Do you want to Close Jobcard ?"}
          onOk={() => {
            handleCloseJobcard();
            setStatusCloseModel(false);
          }}
          onHide={() => setStatusCloseModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}

      {consumptionQtyModal && (
        <ConsumptionQuantityModal
          show={setOkQtyModal}
          onHide={handleModalClose}
          title={consumptionModalTitle}
          jobStatusCode={consumptionModalType}
          deptCode={jobcardDetails.toDeptCode}
          sizeCode={jobcardDetails.sizeCode}
          jobcardDetails={jobcardDetails}
          pendingConsumptionData={editConsumptionData}
          savedConsumptionData={savedConsumptionData}
          consumptionReasonsList={consumptionReasonsList}
          onSaveSuccess={handleSaveSuccess}
        ></ConsumptionQuantityModal>
      )}
    </main>
  );
};

export default OrderConfirmation;
